// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"216":"48cd78d400fb249e","2013":"f0992c542604ad58","3807":"9f55fe3e24dd3843","6927":"072ef06e15d1ab7a","9099":"91af4a4e18c7cf94"}[chunkId] + ".js";
};